import { render, staticRenderFns } from "./EventBanner.vue?vue&type=template&id=1e6ac677&"
import script from "./EventBanner.vue?vue&type=script&lang=js&"
export * from "./EventBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports